import * as React from "react";
import { AppRoutes } from "./router/AppRoutes";
import { AuthProvider } from "./contexts/AuthContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterLuxon } from "@mui/x-date-pickers-pro/AdapterLuxon";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { Button } from "@mui/material";
import RootErrorBoundary from "./components/layout/RootErrorBoundary";
import { ReactScan } from "./components/tools/ReactScan";

const queryClient = new QueryClient();

export default function App() {
  return (
    <RootErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            dense
            preventDuplicate
            action={(snackbarKey) => (
              <Button
                onClick={() => closeSnackbar(snackbarKey)}
                size="small"
                sx={{ color: "white" }}
              >
                Dismiss
              </Button>
            )}
          >
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </SnackbarProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </LocalizationProvider>
    </RootErrorBoundary>
  );
}
